/* @ngInject */
const myLoadingBar = (
  utils,
  valueHandler
) => {
  return {
    restrict: 'E',
    scope: {
      myUse: '=',
      myAvailable: '=',
      myTotal: '=',
    },
    template: require('./myLoadingBar.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.progress = '0%'

      $scope.$watchCollection('[myTotal, myUse, myAvailable]', () => {
        let total = parseFloat($scope.myTotal)
        let use = 0

        if (valueHandler.isNumber($scope.myUse)) {
          use = parseFloat($scope.myUse)
        } else if (valueHandler.isNumber($scope.myAvailable)) {
          use = total - parseFloat($scope.myAvailable)
        }
        $scope.overLoad = false

        if (use > total) {
          const temp = use
          use = total
          total = temp
          $scope.overLoad = true
        }

        const ProgressString = '' + (use / total) * 100 + '%'
        $scope.progress = ProgressString
      })
    },
    link: (scope, element, attrs, ctrl) => {

    },
  }
}

export default myLoadingBar



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/loading/myLoadingBar.js